import React from 'react';
import { useAPIContext } from '../../../context/api';
import { BrandsAPI } from '../../../../../constructs/brands/interface';
import { ReviewFieldKey } from '../../../types/banner/review-fields';

export const useUpdateReviewBanner = () => {
  const { callEndpoint } = useAPIContext();

  const updateReviewBanner = React.useCallback(
    async (bannerId: string, fieldKey: ReviewFieldKey, content: string) => {
      try {
        const res = await callEndpoint<BrandsAPI, 'update-banner-review'>(
          'brands',
          `/banners/${bannerId}/review`,
          'POST',
          {
            fieldKey,
            content
          }
        );

        return res;
      } catch (error) {
        console.error('Error updating banner review:', error);
      }
    },
    [callEndpoint]
  );

  return { updateReviewBanner };
};
